import { FoodTone } from '../../core/models/menu.model';

export interface ToneDef { g: string; icon: string; }

/** Gradient + emoji-icon per food tone, used by the CSS food placeholders. */
export const FOOD_TONES: Record<FoodTone, ToneDef> = {
  beef:   { g: 'radial-gradient(120% 100% at 30% 20%, #d99a5b 0%, #9c5a2c 42%, #5e3417 100%)', icon: 'fluent-emoji-high-contrast:hamburger' },
  spicy:  { g: 'radial-gradient(120% 100% at 30% 20%, #f0a04b 0%, #d8492a 45%, #7e1f12 100%)', icon: 'fluent-emoji-high-contrast:hot-pepper' },
  chicken:{ g: 'radial-gradient(120% 100% at 30% 20%, #f0c168 0%, #c9893a 45%, #7e4f1d 100%)', icon: 'fluent-emoji-high-contrast:fried-shrimp' },
  fries:  { g: 'radial-gradient(120% 100% at 30% 20%, #f6cf6a 0%, #e3a637 45%, #9a6516 100%)', icon: 'fluent-emoji-high-contrast:french-fries' },
  plant:  { g: 'radial-gradient(120% 100% at 30% 20%, #9fd07a 0%, #4f9a4a 45%, #265c2c 100%)', icon: 'fluent-emoji-high-contrast:leafy-green' },
  shake:  { g: 'radial-gradient(120% 100% at 30% 20%, #f6dbe6 0%, #e0a3bf 45%, #9c5f7d 100%)', icon: 'fluent-emoji-high-contrast:cup-with-straw' },
  cola:   { g: 'radial-gradient(120% 100% at 30% 20%, #8a5a3a 0%, #4a2a1c 45%, #241310 100%)', icon: 'fluent-emoji-high-contrast:cup-with-straw' },
  lemon:  { g: 'radial-gradient(120% 100% at 30% 20%, #f3e07a 0%, #d6c23f 45%, #8f8021 100%)', icon: 'fluent-emoji-high-contrast:lemon' },
  dessert:{ g: 'radial-gradient(120% 100% at 30% 20%, #e0b27e 0%, #9c6435 45%, #59351a 100%)', icon: 'fluent-emoji-high-contrast:cookie' },
};

export function toneDef(tone: FoodTone | string | undefined): ToneDef {
  return FOOD_TONES[(tone as FoodTone)] || FOOD_TONES.beef;
}
